var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
/**
 * 添加 Request 拦截器，返回值为 number，可用于 eject 方法
 */
axios.interceptors.request.use(
/** onFulfilled */
function (config) {
    // Do something before request is sent
    switch (true) {
        case /(post|put)/.test("" + config.method):
            // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
            break;
        default:
            break;
    }
    return config;
}, 
/** onRejected */
function (error) {
    // Do something with request error
    return Promise.reject(error);
});
/**
 * 添加 Response 拦截器，返回值为 number，可用于 eject 方法
 */
axios.interceptors.response.use(
/** onFulfilled */
function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    response.data = {
        code: response.data.code || response.data.errcode || 200,
        message: response.data.message || response.data.errmsg,
        success: response.data.success || response.data.status,
        data: response.data.data || response.data.result,
        total: response.data.total || response.data.totalCounts,
    };
    return response;
}, 
/** onRejected */
function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});
/**
 * 全局默认值
 */
axios.defaults.withCredentials = true;
axios.defaults.headers = {
    'X-Requested-With': 'XMLHttpRequest',
};
export var Ajax = function (option) { return __awaiter(void 0, void 0, Promise, function () {
    var api, parameter, config, _a, method, url;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                api = option.api, parameter = option.parameter, config = __rest(option, ["api", "parameter"]);
                _a = api.split(' '), method = _a[0], url = _a[1];
                return [4 /*yield*/, axios
                        .request(__assign(__assign((_b = { url: url,
                            method: method }, _b[/(get)/.test(method) ? 'params' : 'data'] = parameter, _b), config), { headers: __assign(__assign({}, config.headers), { domain: window.location.origin, 'jwt-token': sessionStorage.getItem('token') }) }))
                        .then(function (response) {
                        /** result 后台返回结果 */
                        var result = response.data;
                        if (['USER20025', '207009-3'].includes("" + result.code)) {
                            return result;
                        }
                        if (result.success === false) {
                            throw new Error(result.message);
                        }
                        return result;
                    })
                        .catch(function (error) {
                        switch (true) {
                            case error.response !== void 0: {
                                // 请求已发出，服务器返回了超出 2xx 范围的状态码
                                if (error.response.status === 401) {
                                    window.location.href = '/login';
                                }
                                throw {
                                    name: 'HttpError',
                                    message: error.message,
                                    code: "" + error.response.status,
                                };
                            }
                            case error.request !== void 0: // 请求已发出，但是未收到服务器回复(网络异常)
                                throw {
                                    name: 'NetworkError',
                                    message: error.message,
                                    code: '408',
                                };
                            default:
                                throw error;
                        }
                    })];
            case 1: return [2 /*return*/, _c.sent()];
        }
    });
}); };
export default Ajax;
